import styled, { css } from "styled-components";
import media from "constants/media";

export const ConfiguratorStyled = styled.div`
    position: relative;

    margin: 43px 0 40px;

    ${media.mdUp`
        max-width: 55%;
        min-height: 605px;
        margin: -400px 0 17% calc(50% - 80px);
    `}

    ${media.lgUp`
        max-width: 680px;
        margin-top: -415px;
    `}
`;

export const Switch = styled.div`
    height: 0;

    visibility: hidden;

    ${({ show }) =>
        show &&
        css`
            height: auto;

            visibility: visible;
        `}
`;

export const Form = styled.form`
    position: relative;

    padding: 20px 10px;

    ${media.mdUp`
        padding: 20px 25px;

        background-color: var(--color-white);

        box-shadow: 10px 10px 24px 0 rgba(0, 23, 75, 0.05);
    `}

    ${media.lgUp`
        padding: 30px 40px;
    `}
`;

export const Title = styled.h2`
    margin-bottom: 20px;

    font-size: 25px;
    font-family: var(--font-DINProCondensed);
    line-height: 30px;
    letter-spacing: 1px;
    text-align: center;
    text-transform: uppercase;

    ${media.mdUp`
        margin-bottom: 35px;

        font-size: 34px;
        line-height: 40px;
        text-align: left;
    `}
`;

export const Placeholder = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 35px 40px;

    background-color: var(--color-white);
    box-shadow: 3px 3px 7px 0 rgba(0, 23, 75, 0.05);
`;

export const Icon = styled.img`
    width: 20px;
    height: auto;
    margin-right: 22px;
`;
